// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user_innercontents__YRj33 .user_addbtn__JI2Ev {
  font-size: 1.9vh !important;
  width: fit-content;
  padding: 0.5vh 2vh;
  border-radius: 0.4vh;
}
.user_cardtitle__pdREa {
  color: #2d699b;
  font-size: 2vh;
  margin-top: 2vh;
}
.user_dummyimg__PEctX {
  width: 7vh;
  height: 7vh;
}
.user_mes__mrhX7 {
  margin-right: 2vh;
}
.user_mtb__8ZrcL {
  margin-top: 2vh;
  margin-bottom: 2vh;
  color: #2d699b;
}
.user_mbspace__qV-Cz {
  margin-top: 2vh;
}
.user_mts__L8ZUe {
  margin-top: 2.5vh;
}
.user_innercontents__YRj33 .user_tablesec__HlXMm {
  /* background: var(--sideclr); */
  background: var(--whtclr);
  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
  border-radius: 6px;
  padding: 2%;
  border-radius: 0.9vh;
  margin-top: 2vh;
}
.user_innercontents__YRj33 .user_tablesec__HlXMm table {
  background: transparent;
  border: 0.1vh solid var(--borderclr);
}
.user_innercontents__YRj33 .user_tablesec__HlXMm table tr th {
  background: none;
  color: var(--themecolor2);
  font-size: 2.5vh;
  padding: 0.5vw;
  background-repeat: no-repeat;
  background-position: right;
  text-wrap: nowrap;
}
.user_innercontents__YRj33 .user_tablesec__HlXMm table tr td {
  background: none;
  color: #fff;
  font-size: 2.2vh;
  padding: 0.5vw;
  vertical-align: baseline;
}
.user_innercontents__YRj33 .user_tablesec__HlXMm table tr [class="action"] {
  text-align: center;
}
.user_innercontents__YRj33 .user_tablesec__HlXMm table tbody tr {
  /* border: none ; */
}
.user_innercontents__YRj33
  .user_tablesec__HlXMm
  [class="table-foot asrt-table-foot"]
  [class="col-md-6"]:first-child {
}

.user_innercontents__YRj33
  .user_tablesec__HlXMm
  div[class="input-group asrt-page-length"]
  [class="input-group-addon input-group-prepend"] {
  background: none;
  margin-bottom: 1.5vh;
}

.user_innercontents__YRj33
  .user_tablesec__HlXMm
  div[class="input-group asrt-page-length"]
  [class="input-group-addon input-group-prepend"]
  [class="input-group-text"] {
  color: var(--themecolor2);
  font-size: 1.5vh;
}
.user_innercontents__YRj33 .user_tablesec__HlXMm div[class="input-group asrt-page-length"] select {
  border: 0.1vh solid var(--borderclr);
  background: none;
  color: var(--themecolor2);
  outline: 0;
  box-shadow: none;
  cursor: pointer;
  font-size: 1.5vh;
  width: fit-content !important;
  margin: 0% 3% !important;
  padding: 0.5vw 1vw;
}

.user_innercontents__YRj33 .user_tablesec__HlXMm [class="row table-body asrt-table-body"] {
  margin-top: 0 !important;
  overflow: auto;
}
.user_innercontents__YRj33
  .user_tablesec__HlXMm
  [class="row table-foot asrt-table-foot"]
  [class="col-md-6"] {
  color: var(--themecolor2);
  font-size: 1.8vh;
  padding: 0vh 2vh;
  margin-bottom: 2vh;
}
.user_innercontents__YRj33 .user_tablesec__HlXMm [class="col-md-6 pull-right text-right"] {
  margin-bottom: 2vh;
}
.user_innercontents__YRj33 .user_tablesec__HlXMm [class="row table-head asrt-table-head"] {
  margin-bottom: 2vh;
}
.user_innercontents__YRj33
  .user_tablesec__HlXMm
  [class="pagination justify-content-end asrt-pagination"]
  li
  a {
  padding: 0.5vw;
  font-size: 1.8vh;
  color: var(--themecolor2);
  background: none;
  border: 0.1vw solid var(--borderclr);
}
.user_innercontents__YRj33
  .user_tablesec__HlXMm
  [class="pagination justify-content-end asrt-pagination"]
  li
  a
  input {
  background: none;
  color: var(--themecolor2);
  box-shadow: none;
  outline: 0;
  max-width: 3vw !important;
}
.user_innercontents__YRj33 .user_tablesec__HlXMm [class="table_filter"] input {
  background: none;
  border: 0.1vw solid var(--borderclr);
  color: var(--themecolor2);
  padding: 0.4vw 0.5vw;
  font-size: 1.7vh;
  color: #fff;
  outline: 0;
  box-shadow: none;
}
.user_innercontents__YRj33 .user_tablesec__HlXMm [class="table_filter"] {
  width: 15vw !important;
  margin-right: 2vw !important;
}
.user_innercontents__YRj33 .user_tablesec__HlXMm [class="table_filter"] input::placeholder {
  color: var(--borderclr);
}
.user_innercontents__YRj33
  .user_tablesec__HlXMm
  [class="row table-head asrt-table-head"]
  [class="col-md-6 float-right text-right"] {
  display: flex;
  justify-content: end;
}
.user_innercontents__YRj33 .user_tablesec__HlXMm [class="input-group asrt-page-length"] {
  display: none;
}
.user_editbtn__COcnV {
  color: var(--themecolor2);
  font-size: 3vh;
  padding: 0.5vh 1vw;
  border: none;
  background: none;
}
.user_kyc_proof__CuMDt {
  display: flex;
  align-items: center;
  gap: 2vw;
  flex-wrap: wrap;
}
.user_kyc_proof_img__pUGZs {
  width: 20vh;
  height: 20vh;
  border-radius: 0.8vw;
  object-fit: cover;
}
@media screen and (max-width: 1199px) {
  .user_innercontents__YRj33 .user_tablesec__HlXMm [class="table_filter"] {
    width: 100% !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/user.module.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,uCAAuC;EACvC,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,oCAAoC;AACtC;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,4BAA4B;EAC5B,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;;;;AAIA;;AAEA;;;;EAIE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;;;;EAKE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,yBAAyB;EACzB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,cAAc;AAChB;AACA;;;;EAIE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;;;;;EAKE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,oCAAoC;AACtC;AACA;;;;;;EAME,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,uBAAuB;AACzB;AACA;;;;EAIE,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".innercontents .addbtn {\r\n  font-size: 1.9vh !important;\r\n  width: fit-content;\r\n  padding: 0.5vh 2vh;\r\n  border-radius: 0.4vh;\r\n}\r\n.cardtitle {\r\n  color: #2d699b;\r\n  font-size: 2vh;\r\n  margin-top: 2vh;\r\n}\r\n.dummyimg {\r\n  width: 7vh;\r\n  height: 7vh;\r\n}\r\n.mes {\r\n  margin-right: 2vh;\r\n}\r\n.mtb {\r\n  margin-top: 2vh;\r\n  margin-bottom: 2vh;\r\n  color: #2d699b;\r\n}\r\n.mbspace {\r\n  margin-top: 2vh;\r\n}\r\n.mts {\r\n  margin-top: 2.5vh;\r\n}\r\n.innercontents .tablesec {\r\n  /* background: var(--sideclr); */\r\n  background: var(--whtclr);\r\n  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);\r\n  border-radius: 6px;\r\n  padding: 2%;\r\n  border-radius: 0.9vh;\r\n  margin-top: 2vh;\r\n}\r\n.innercontents .tablesec table {\r\n  background: transparent;\r\n  border: 0.1vh solid var(--borderclr);\r\n}\r\n.innercontents .tablesec table tr th {\r\n  background: none;\r\n  color: var(--themecolor2);\r\n  font-size: 2.5vh;\r\n  padding: 0.5vw;\r\n  background-repeat: no-repeat;\r\n  background-position: right;\r\n  text-wrap: nowrap;\r\n}\r\n.innercontents .tablesec table tr td {\r\n  background: none;\r\n  color: #fff;\r\n  font-size: 2.2vh;\r\n  padding: 0.5vw;\r\n  vertical-align: baseline;\r\n}\r\n.innercontents .tablesec table tr [class=\"action\"] {\r\n  text-align: center;\r\n}\r\n.innercontents .tablesec table tbody tr {\r\n  /* border: none ; */\r\n}\r\n.innercontents\r\n  .tablesec\r\n  [class=\"table-foot asrt-table-foot\"]\r\n  [class=\"col-md-6\"]:first-child {\r\n}\r\n\r\n.innercontents\r\n  .tablesec\r\n  div[class=\"input-group asrt-page-length\"]\r\n  [class=\"input-group-addon input-group-prepend\"] {\r\n  background: none;\r\n  margin-bottom: 1.5vh;\r\n}\r\n\r\n.innercontents\r\n  .tablesec\r\n  div[class=\"input-group asrt-page-length\"]\r\n  [class=\"input-group-addon input-group-prepend\"]\r\n  [class=\"input-group-text\"] {\r\n  color: var(--themecolor2);\r\n  font-size: 1.5vh;\r\n}\r\n.innercontents .tablesec div[class=\"input-group asrt-page-length\"] select {\r\n  border: 0.1vh solid var(--borderclr);\r\n  background: none;\r\n  color: var(--themecolor2);\r\n  outline: 0;\r\n  box-shadow: none;\r\n  cursor: pointer;\r\n  font-size: 1.5vh;\r\n  width: fit-content !important;\r\n  margin: 0% 3% !important;\r\n  padding: 0.5vw 1vw;\r\n}\r\n\r\n.innercontents .tablesec [class=\"row table-body asrt-table-body\"] {\r\n  margin-top: 0 !important;\r\n  overflow: auto;\r\n}\r\n.innercontents\r\n  .tablesec\r\n  [class=\"row table-foot asrt-table-foot\"]\r\n  [class=\"col-md-6\"] {\r\n  color: var(--themecolor2);\r\n  font-size: 1.8vh;\r\n  padding: 0vh 2vh;\r\n  margin-bottom: 2vh;\r\n}\r\n.innercontents .tablesec [class=\"col-md-6 pull-right text-right\"] {\r\n  margin-bottom: 2vh;\r\n}\r\n.innercontents .tablesec [class=\"row table-head asrt-table-head\"] {\r\n  margin-bottom: 2vh;\r\n}\r\n.innercontents\r\n  .tablesec\r\n  [class=\"pagination justify-content-end asrt-pagination\"]\r\n  li\r\n  a {\r\n  padding: 0.5vw;\r\n  font-size: 1.8vh;\r\n  color: var(--themecolor2);\r\n  background: none;\r\n  border: 0.1vw solid var(--borderclr);\r\n}\r\n.innercontents\r\n  .tablesec\r\n  [class=\"pagination justify-content-end asrt-pagination\"]\r\n  li\r\n  a\r\n  input {\r\n  background: none;\r\n  color: var(--themecolor2);\r\n  box-shadow: none;\r\n  outline: 0;\r\n  max-width: 3vw !important;\r\n}\r\n.innercontents .tablesec [class=\"table_filter\"] input {\r\n  background: none;\r\n  border: 0.1vw solid var(--borderclr);\r\n  color: var(--themecolor2);\r\n  padding: 0.4vw 0.5vw;\r\n  font-size: 1.7vh;\r\n  color: #fff;\r\n  outline: 0;\r\n  box-shadow: none;\r\n}\r\n.innercontents .tablesec [class=\"table_filter\"] {\r\n  width: 15vw !important;\r\n  margin-right: 2vw !important;\r\n}\r\n.innercontents .tablesec [class=\"table_filter\"] input::placeholder {\r\n  color: var(--borderclr);\r\n}\r\n.innercontents\r\n  .tablesec\r\n  [class=\"row table-head asrt-table-head\"]\r\n  [class=\"col-md-6 float-right text-right\"] {\r\n  display: flex;\r\n  justify-content: end;\r\n}\r\n.innercontents .tablesec [class=\"input-group asrt-page-length\"] {\r\n  display: none;\r\n}\r\n.editbtn {\r\n  color: var(--themecolor2);\r\n  font-size: 3vh;\r\n  padding: 0.5vh 1vw;\r\n  border: none;\r\n  background: none;\r\n}\r\n.kyc_proof {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 2vw;\r\n  flex-wrap: wrap;\r\n}\r\n.kyc_proof_img {\r\n  width: 20vh;\r\n  height: 20vh;\r\n  border-radius: 0.8vw;\r\n  object-fit: cover;\r\n}\r\n@media screen and (max-width: 1199px) {\r\n  .innercontents .tablesec [class=\"table_filter\"] {\r\n    width: 100% !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"innercontents": `user_innercontents__YRj33`,
	"addbtn": `user_addbtn__JI2Ev`,
	"cardtitle": `user_cardtitle__pdREa`,
	"dummyimg": `user_dummyimg__PEctX`,
	"mes": `user_mes__mrhX7`,
	"mtb": `user_mtb__8ZrcL`,
	"mbspace": `user_mbspace__qV-Cz`,
	"mts": `user_mts__L8ZUe`,
	"tablesec": `user_tablesec__HlXMm`,
	"editbtn": `user_editbtn__COcnV`,
	"kyc_proof": `user_kyc_proof__CuMDt`,
	"kyc_proof_img": `user_kyc_proof_img__pUGZs`
};
export default ___CSS_LOADER_EXPORT___;
